import { render, staticRenderFns } from "./TreatmentDirectoryModal.vue?vue&type=template&id=694961d5"
import script from "./TreatmentDirectoryModal.vue?vue&type=script&lang=js"
export * from "./TreatmentDirectoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports